var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGameCategoryMinermadness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4233.32 4233.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    d: "M2116.66 529.11c389.6,0.07 705.54,316 705.54,705.61 0,128.73 -33.47,248.67 -95.2,352.73l448 0c167.6,0 308.67,118.2 343.94,275.21 354.6,1412.88 361.6,1449.94 361.6,1488.74 0.07,194.74 -157.93,352.74 -352.73,352.74l-2822.31 0.07c-194.73,-0.07 -352.73,-158.07 -352.73,-352.87 0,-38.74 7,-75.8 361.6,-1488.68 35.27,-157.01 176.34,-275.21 343.94,-275.21l448 0c-61.73,-104.06 -95.2,-224 -95.2,-352.73 0.07,-389.61 316.01,-705.54 705.55,-705.54l0 -0.07zm0 352.8c-194.74,0 -352.74,158 -352.74,352.81 0,194.8 158,352.8 352.74,352.8 194.8,0 352.8,-158 352.8,-352.8 0,-194.81 -158,-352.81 -352.8,-352.81z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameCategoryMinermadness);
export default __webpack_public_path__ + "static/media/icon-game-category-minermadness.47fab1e3448734a347bea36a18808fe5.svg";
export { ForwardRef as ReactComponent };